export function isNumber(value: unknown) {
  return value !== null && value !== undefined && typeof value === "number";
}
